import NumbersAnimationProvider from 'app/components/AnimationProviders/NumbersAnimationProvider'
import FireStreakLabel from './FireStreakLabel'

export default NumbersAnimationProvider(FireStreakLabel)
